import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { ContactRequest } from '@interfaces';
import { AppService, BaseEngagementService } from '../../../../../services';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';

export function getSetup(pageService: BaseEngagementService, util: UtilityService, dialogService: DialogService, app: AppService): GridSetup<ContactRequest> {
	return {
		rowName: { singular: 'Contact Request', plural: 'Contact Requests' },
		getRowKey: row => '' + row.contactRequestId,
		stateKey: (`${pageService.page()}-contact-request-grid`).toLowerCase(),
		actions: getActions(dialogService, pageService),
		buttons: [],
		columns: getColumns(util, app),
		renderRowClasses: row => !row.closed ? [] : ['grid-cell-strikethrough', 'grid-cell-gray-text'],
		multiselect: false,
	}
}
